import { render, staticRenderFns } from "./LicitacoesLista.vue?vue&type=template&id=3dfe1889&scoped=true&"
import script from "./LicitacoesLista.vue?vue&type=script&lang=js&"
export * from "./LicitacoesLista.vue?vue&type=script&lang=js&"
import style0 from "./LicitacoesLista.vue?vue&type=style&index=0&id=3dfe1889&lang=scss&scoped=true&"
import style1 from "./LicitacoesLista.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfe1889",
  null
  
)

export default component.exports